import { Injectable } from '@angular/core';
import {Http, Response, RequestOptions, Headers } from '@angular/http';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';



@Injectable()
export class ImportTemplateService extends ParentService {
  public progressObserver: any;
  public progress: any;
  constructor(
    private _http: Http
  ) { super(); }


  /**
   * @name getTotalService
   * @description para traer dinamicamente segun la uri
   */
  public getTotalService(uri: string): Observable<any> {
    return this._http.get(constant.BASIC + uri, this.getHeader())
      .map( res => res.json());
  }

  /**
   * @name postFile
   * @description para enviar file y resivir datos
   */
  public postFile(files: File[]): Observable<any> {

    return Observable.create(observer => {
      this.progressObserver = observer;

      const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      for (let i = 0; i < files.length; i++) {
        formData.append('uploads[]', files[i], files[i].name);
      }

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(JSON.parse(xhr.response));
            observer.complete();
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round((event.loaded / event.total) * 100);
        this.progressObserver.next(this.progress);
      };
      xhr.open('POST', constant.URL_IMPORT_PAYOR_READFILE, true);
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      xhr.setRequestHeader('Authorization', `Session ${token}`);
      xhr.send(formData);
    });
  }



}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/import-template.service.ts